// app/javascript/controllers/expertises_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expertiseSelect"]

  connect() {

    const tagSelect = this.element.querySelector("#floatingTag")

    if (tagSelect && tagSelect.value) {

      this.loadTags({ target: tagSelect })

    }

  }

  loadTags(event) {
    const tagId = event.target.value
    if (!tagId) {
      // Bei leerem Tag: Liste leeren
      this.expertiseSelectTarget.innerHTML = '<option value="">Expertise wählen</option>'
      return
    }

    const selectedExpertiseId = this.expertiseSelectTarget.value // aktives Feld verwenden
    const url = `/candidates/${event.target.form.dataset.candidateId}/candidate_expertises/fetch_expertises.json?tag_id=${tagId}`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.expertiseSelectTarget.innerHTML = '<option value="">Expertise wählen</option>' // resetten
        data.forEach((expertise) => {
          const option = document.createElement("option")
          option.value = expertise.id
          option.textContent = expertise.description
          if (selectedExpertiseId == expertise.id.toString()) {
            option.selected = true
          }
          this.expertiseSelectTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Fehler beim Laden der Expertises:", error)
      })
  }

  closeForm() {
    this.element.closest("form").remove() // oder:
    // this.element.closest(".form-container").classList.add("d-none")
  }

}